import { render, staticRenderFns } from "./FloorPlanSeatColorPicker.vue?vue&type=template&id=254feba1&scoped=true"
import script from "./FloorPlanSeatColorPicker.vue?vue&type=script&lang=js"
export * from "./FloorPlanSeatColorPicker.vue?vue&type=script&lang=js"
import style0 from "./FloorPlanSeatColorPicker.vue?vue&type=style&index=0&id=254feba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254feba1",
  null
  
)

export default component.exports